class SearchModal extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector("#predictive__search_overlay");
    this.closeButton = this.querySelector(".modal__close-button");
    this.overlay = this.querySelector(".offcanvas-overlay");

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.closeButton?.addEventListener("click", this.close.bind(this));
    this.overlay?.addEventListener("click", this.close.bind(this));
    this.setHeaderSearchIconAccessibility();
  }

  setHeaderSearchIconAccessibility() {
    const searchIconButtons = document.querySelectorAll(".header__actions_btn--search");
    searchIconButtons.forEach((searchIconButton) => {
      searchIconButton.setAttribute("role", "button");
      searchIconButton.setAttribute("aria-haspopup", "dialog");
      searchIconButton.setAttribute("aria-controls", "predictive__search_overlay");
      searchIconButton.setAttribute("aria-expanded", "false");
      searchIconButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(searchIconButton);
      });
    });
  }

  open(triggeredBy) {
    if (!this.dialog) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);

    this.dialog.setAttribute("aria-hidden", "false");
    this.activeElement?.setAttribute("aria-expanded", "true");
    requestAnimationFrame(() => {
      this.classList.add("animate", "active");
      const focusElement = this.querySelector('input[type="search"]') || this.closeButton || this.dialog;
      if (typeof trapFocus === "function") {
        trapFocus(this.dialog, focusElement);
      } else {
        focusElement.focus();
      }
    });
    document.body.classList.add("body-overflow-hidden");
  }

  close() {
    if (!this.dialog || !this.classList.contains("active")) return;
    this.classList.remove("active");
    this.dialog.setAttribute("aria-hidden", "true");
    document.body.classList.remove("body-overflow-hidden");

    const triggerToRestore = this.activeElement;
    triggerToRestore?.setAttribute("aria-expanded", "false");
    if (typeof removeTrapFocus === "function") {
      removeTrapFocus(triggerToRestore);
    } else {
      triggerToRestore?.focus();
    }
    this.activeElement = null;
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get("search-modal")) {
  customElements.define("search-modal", SearchModal);
}
